import React, { useState } from "react";
import "./AddAudioModal.css";

const AddAudioModal = ({ show, onClose, onSave }) => {
  const [audio, setAudio] = useState(null);
  const [caption, setCaption] = useState("");
  const [error, setError] = useState("");

  const handleAudioChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 15 * 1024 * 1024) {
      setError("Audio size must be less than 15MB");
      return;
    }
    if (
      file &&
      !["audio/mpeg", "audio/wav", "audio/ogg", "audio/x-m4a"].includes(
        file.type
      )
    ) {
      setError("Invalid audio type. Allowed types are mp3, wav, ogg, and m4a.");
      return;
    }
    setError("");
    setAudio(file);
  };

  const handleSave = () => {
    if (!audio) {
      setError("Please select an audio file to upload");
      return;
    }
    onSave({ audio, caption });
    onClose();
  };

  if (!show) {
    return null;
  }

  return (
    <div className="add-audio-modal-overlay">
      <div className="add-audio-modal-content">
        <h2>Upload Audio</h2>
        <p>
          Maximum audio size is 15MB. Allowed types are mp3, wav, ogg, and m4a.
        </p>
        {error && <p className="error-message">{error}</p>}
        <input type="file" accept="audio/*" onChange={handleAudioChange} />
        <input
          type="text"
          placeholder="Add a caption"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
        />
        <button onClick={handleSave}>Save</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default AddAudioModal;
